//
import React from "react";
//component
import { Col, Row, Typography } from "antd";
import { DatePicker } from "antd";
//redux
//selector
import { financeSupporterDatesSelector } from "store/bailiff/finance/supporter/finance_supporter.selector";
//actions
import { setFinanceSupporterDates } from "store/bailiff/finance/supporter/finance_supporter.action";
//utils
//hook
import { useSelector, useDispatch } from "react-redux";
import { totalTaskSelector } from "store/bailiff/task/task_count/task_count.selector";
//str

const { RangePicker } = DatePicker;

const HistoryHeaderClone = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const dates = useSelector(financeSupporterDatesSelector);
  const totalTasks = useSelector(totalTaskSelector);
  const historyDes = `Số tiền bạn nhận được từ (${totalTasks}) việc làm`;
  // -------------------------- FUNCTION ------------------------
  const handleChange = (dates) => {
    dispatch(setFinanceSupporterDates(dates));
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row gutter={[10, 10]}>
        <Col xl={12} lg={12} md={24} xs={24}>
          <Typography.Title style={{ margin: "10px 0px" }} level={4}>
            Lịch sử nhận tiền
          </Typography.Title>
          <Typography.Text type="secondary">{historyDes}</Typography.Text>
        </Col>
        <Col
          style={{ display: "flex", alignItems: "end", justifyContent: "end" }}
          xl={12}
          lg={12}
          md={24}
          xs={24}
        >
          {renderSelectRange()}
        </Col>
      </Row>
    );
  };

  const renderSelectRange = () => {
    return (
      <RangePicker
        value={dates}
        onChange={handleChange}
        placeholder={["Từ ngày", "Đến ngày"]}
      />
    );
  };

  // -------------------------- MAIN ----------------------------
  return <div style={{ padding: 15 }}>{renderBody()}</div>;
};
export default HistoryHeaderClone;
